export const OBJVAL = 'OBJVAL';
export const OPT_ROV1 = 'OPT_ROV1';
export const OPT_ROV2 = 'OPT_ROV2';
